import React, { useMemo } from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import HomeScreen from '../../screens/HomeScreen';
import { useTheme } from '../../theme';

type EmployeeHomeTabsParamList = {
  HomeMain: undefined;
};

const Stack = createNativeStackNavigator<EmployeeHomeTabsParamList>();

const EmployeeHomeTabNavigator: React.FC = () => {
  const { theme } = useTheme();
  const stackScreenOptions = useMemo(
    () => ({
      headerShown: false,
      contentStyle: {
        backgroundColor: theme.colors.background,
      },
    }),
    [theme.colors.background],
  );

  return (
    <Stack.Navigator screenOptions={stackScreenOptions}>
      <Stack.Screen name="HomeMain" component={HomeScreen} />
    </Stack.Navigator>
  );
};

export default EmployeeHomeTabNavigator;
